module.exports = __webpack_public_path__ + "img/jifen.5d703418.png";